<template>
  <div>
    <canvas :id="chartPieId"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'TheChartPie',
  mounted () {
    this.createChart(this.chartPieId, this.chartPie)
  },
  data () {
    return {
      chartPie: {
        type: 'pie',
        data: {
          labels: this.chartPieLabes,
          datasets: [{
            data: this.chartPieItems,
            backgroundColor: this.chartPieItemsBackgroundColor,
            borderWidth: [0, 0, 0]
          }]
        },
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          legend: {
            display: true,
            position: 'left',
            labels: {
              boxWidth: 15,
              padding: 10,
              fontFamily: 'Hind',
              fontSize: 14,
              fontColor: '#4c4c4c',
              usePointStyle: true
            }
          },
          tooltips: {
            mode: 'nearest',
            backgroundColor: 'rgba(27,74,138, 1)',
            caretSize: 5,
            displayColors: false,
            bodyFontSize: 25,
            bodyFontFamily: 'Montserrat',
            bodyFontStyle: '700',
            callbacks: {
              label: (tooltipItem, data) => {
                var currentIndex = tooltipItem.index
                var percent = data.datasets[tooltipItem.datasetIndex].data
                var newText = `${percent[currentIndex]}%`

                return newText
              }
            }
          }
        }
      },
      currentChart: {},
      tooltipEl: {}
    }
  },
  props: {
    chartPieId: {
      type: String
    },
    chartPieLabes: {
      type: Array
    },
    chartPieItems: {
      type: Array
    },
    chartPieItemsBackgroundColor: {
      type: Array
    },
    chartPieUpdated: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1
      }
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    createChart (chartId, chartPie) {
      const ctx = document.getElementById(chartId)
      this.currentChart = new Chart(ctx, {
        type: chartPie.type,
        data: chartPie.data,
        options: chartPie.options
      })
    }
  },
  filters: {
  },
  watch: {
    chartPieUpdated (newValue, oldValue) {
      if (newValue === true) {
        let newData = {
          labels: this.chartPieLabes,
          datasets: [{
            data: this.chartPieItems,
            backgroundColor: this.chartPieItemsBackgroundColor
          }]
        }
        this.currentChart.data = newData
        this.currentChart.update()

        this.$emit('returned-chart-pie-updated', false)
      }
    }
  }
}
</script>

<style  lang="scss">
</style>
